module.exports = __webpack_public_path__ + "img/cooperate_12.b7c32349.png";